import { DateTimePicker, DateTimePickerAndroid } from '@react-native-community/datetimepicker';
import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput, Linking, Pressable, TouchableOpacity, Platform } from 'react-native';
import { EvilIcons, Entypo } from '@expo/vector-icons'; 
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import css from './Style'
import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';

const MyModal = ({ enabled, header, body, callback, closeModal }) => {

    return (
        <>
            {enabled &&
                <View style={styles.bg}>
                    <View style={styles.modal}>
                        <View style={styles.header}>
                            <MyText style={[{fontSize: 18, color: '#461b6f'}, css.bold]}>
                                {header}
                            </MyText>
                        </View>
                        <MyText style={styles.body}>
                            {body.split('support@mdata.gr')[0]}
                            {
                                body.split('support@mdata.gr').length > 1?
                                // <Pressable style={{}} onPress={() => Linking.openURL('mailto:support@mdata.gr')}>
                                    <MyText onPress={() => Linking.openURL('mailto:support@mdata.gr')} style={{color: 'blue', textDecorationLine: 'underline'}}>support@mdata.gr</MyText>
                                // </Pressable>
                                :
                                ''
                            }
                            {body.split('support@mdata.gr')[1]??''}
                        </MyText>
                        <View style={styles.footer}>
                            { !callback &&
                                <TouchableOpacity onPress={closeModal} style={{alignItems: 'center', marginBottom: 0}}>
                                    <MyText style={[{paddingVertical: 10, paddingHorizontal: 30, backgroundColor: '#461b6f', color: 'white', borderRadius: 12, overflow: 'hidden'}, css.bold]}>
                                        OK
                                    </MyText>
                                </TouchableOpacity>
                            }
                            { callback &&
                                <>
                                    <TouchableOpacity onPress={() => {closeModal(); callback();}} style={{alignItems: 'center', marginBottom: 0}}>
                                        <MyText style={[{paddingVertical: 10, paddingHorizontal: 30, backgroundColor: '#461b6f', color: 'white', borderRadius: 12, marginRight: 15, overflow: 'hidden'}, css.bold]}>
                                            Yes
                                        </MyText>
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={closeModal} style={{alignItems: 'center', marginBottom: 0}}>
                                        <MyText style={[{paddingVertical: 10, paddingHorizontal: 30, backgroundColor: '#461b6f', color: 'white', borderRadius: 12, overflow: 'hidden'}, css.bold]}>
                                            No
                                        </MyText>
                                    </TouchableOpacity>
                                </>
                            }
                        </View>
                    </View>
                </View>
            }
        </>
    );
}
const styles = StyleSheet.create({
    bg: {
        backgroundColor: 'rgba(0, 0, 0, 0.38)',
        position: 'absolute',
        left: 0,
        top: Platform.OS==='web'?64:94,
        right: 0,
        bottom: 0,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modal: {
        backgroundColor: 'white',
        borderRadius: 8,
        overflow: 'hidden',
        width: 300,
        maxWidth: '95%',
    },
    header: {
        padding: 10,
        alignItems: 'center'
    },
    body: {
        borderTopWidth: 1,
        borderTopColor: '#dee2e6',
        borderBottomColor: '#dee2e6',
        padding: 15,
        paddingBottom: 5,
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: 20
    },
    footer: {
        padding: 10,
        // flex: 1,
        // display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    }
})

const mapStateToProps = (state) => ({
    enabled: state.enabled,
    header: state.header,
    body: state.body,
    callback: state.callback
})

const mapDispatchToProps = {
    openModal,
    closeModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(MyModal)